import { useDebounce } from '@uidotdev/usehooks'
import { useMemo } from 'react'

import { BillCustomerTextCombobox } from '@/components/pages/Admin/BillManagement/Form/BillCustomerTextCombobox'
import { normalizeStringList } from '@/utils/normalizeStringList'
import {
  useWholesaleCustomerFieldSuggestions,
  type WholesaleCustomerField,
} from '@/modules/bill/services/bill'

type BillWholesaleCustomerFieldProps = {
  customerName: string
  field: WholesaleCustomerField
  value: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
  requiresCustomerHint: string
  className?: string
}

export function BillWholesaleCustomerField({
  customerName,
  field,
  value,
  onChange,
  placeholder,
  disabled,
  requiresCustomerHint,
  className,
}: BillWholesaleCustomerFieldProps) {
  const debouncedValue = useDebounce(value, 250)
  const trimmedCustomer = customerName.trim()
  const { data, isLoading } = useWholesaleCustomerFieldSuggestions(
    trimmedCustomer,
    field,
    debouncedValue,
    true,
  )
  const suggestions = useMemo(() => normalizeStringList(data), [data])

  return (
    <BillCustomerTextCombobox
      value={value}
      onChange={onChange}
      suggestions={trimmedCustomer ? suggestions : []}
      loading={trimmedCustomer ? isLoading : false}
      placeholder={placeholder}
      disabled={disabled}
      emptyHint={!trimmedCustomer ? requiresCustomerHint : undefined}
      className={className}
    />
  )
}
